import {
    provideHttpClient,
    withFetch,
    withInterceptors,
} from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter, UrlSerializer, withInMemoryScrolling } from '@angular/router';

import {
    MapperService,
    SCREEN_SIZER_PARAMS_TOKEN,
    ScreenSizerService,
    SITE_CONFIG_SERVICE_TOKEN,
} from 'ctt-babylon';
import { routes } from './app.routes';
import { ErrorInterceptor } from './interceptors/error-request.interceptor';
import { marketInterceptor } from './interceptors/market.interceptor';
import { InitializerService } from './services/initializer/initializer.service';
import { SiteConfigService } from './services/site-config/site-config.service';
import { provideScrollRestorationAfterFirstPage } from './services/routes/scroll-restoration';
import { TrailingSlashUrlSerializer } from './services/routes/trailing-slash.serializer';

export function initApp(init: InitializerService) {
    return () => init.loadSettings();
}

/* ——— providers que ya tenías, *sin* hydration ——— */
export const commonConfig: ApplicationConfig = {
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (init: InitializerService) => () => init.loadSettings(),
            deps: [InitializerService],
            multi: true,
        },

        provideRouter(
            routes,
            // El scroll lo gestiona provideScrollRestorationAfterFirstPage
            withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })
        ),
        provideScrollRestorationAfterFirstPage(),

        provideHttpClient(
            withInterceptors([marketInterceptor, ErrorInterceptor]),
            withFetch()
        ),

        // UrlSerializer personalizado para manejar trailing slashes
        { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },

        MapperService,
        { provide: SITE_CONFIG_SERVICE_TOKEN, useExisting: SiteConfigService },

        {
            provide: SCREEN_SIZER_PARAMS_TOKEN,
            useValue: {
                pixelBreakpoints: {
                    mobile: 375,
                    smallTablet: 540,
                    mediumTablet: 768,
                    fullTablet: 1024,
                    smallDesktop: 1280,
                    mediumDesktop: 1366,
                    fullDesktop: 1680,
                    fullBigDesktop: 1800,
                    maxDesktop: 1920,
                },
            },
        },

        ScreenSizerService,
    ],
};
